import loader from 'common/assets/svg/common/loader.svg';

type PageLoaderProps = {
  isLoading: boolean;
  className?: string;
};

const PageLoader = ({ isLoading, className = '' }: PageLoaderProps) => {
  return isLoading ? (
    <div className={`page-loader ${className}`}>
      <img alt="page-loader" src={loader} width={48} height={48} />
    </div>
  ) : null;
};

export default PageLoader;
